import script from "./ThemesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesView.vue?vue&type=script&setup=true&lang=js"

import "./ThemesView.vue?vue&type=style&index=0&id=2c1e8e13&lang=scss"

const __exports__ = script;

export default __exports__